<template>
  <div>
    <slidercomponent :lista="listaprops" />
  </div>
</template>

<script>
import Slidercomponent from "@/components/Slidercomponent.vue";

export default {
  components: { Slidercomponent },
  name: "Trysilelva",
  data() {
    return {
      listaprops: [
        {
          id: 0,
          rubrik: "Trysilelva",
          text:
            "Nothing grows faster than a fish from when it bites until it gets away. - Anonym",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-1.jpg"
        },
        {
          id: 1,
          rubrik: "Trysilelva",
          text:
            "Only an extraordinary person would purposely risk being outsmarted by a creature often less than twelve inches long, over and over again. - Janna Bialek",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-2.jpg"
        },
        {
          id: 2,
          rubrik: "Trysilelva",
          text:
            "Fly-fishing may well be considered the most beautiful of all rural sports. - Frank Forester",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-3.jpg"
        },
        {
          id: 3,
          rubrik: "Trysilelva",
          text:
            "Three-fourths of the Earth's surface is water, and one-fourth is land. It is quite clear that the good Lord intended us to spend triple the amount of time fishing as taking care of the lawn. - Chuck Clark",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-4.jpg"
        },
        {
          id: 4,
          rubrik: "Trysilelva",
          text:
            "Time is but the stream I go a-fishing in. Its thin current slides away, but eternity remains. - Henry David Thoreau",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-5.jpg"
        },
        {
          id: 5,
          rubrik: "Trysilelva",
          text:
            "Fly-fishing is the most fun you can have standing up. - Arnold Gingrich",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-6.jpg"
        },
        {
          id: 6,
          rubrik: "Trysilelva",
          text:
            "What a tourist terms a plague of insects, the fly fisher calls a great hatch. - Patrick F. McManus",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-7.jpg"
        },
        {
          id: 7,
          rubrik: "Trysilelva",
          text:
            "Listen to the sound of the river and you will get a trout. - Irish proverb",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-8.jpg"
        },
        {
          id: 8,
          rubrik: "Trysilelva",
          text:
            "The finest gift you can give to any fisherman is to put a good fish back, and who knows if the fish that you caught isn't someone else's gift to you? - Lee Wulff ",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-9.jpg"
        },
        {
          id: 9,
          rubrik: "Trysilelva",
          text:
            "If you fish the wrong fly long and hard enough, it will sooner or later become the right fly. - John Gierach",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-10.jpg"
        }
      ]
    };
  }
};
</script>
